module.exports = __webpack_public_path__ + "static/good-calories-bad-calories-ae098cc8bc1428b19cf792ae38ecbc3a.jpg";